export default __webpack_public_path__ + "static/media/logo-brasil-vale-192x153.a294abbf.jpg";